
/**
 * 默认路由
 */
const defaultRouter = [
    {path: '*', redirect: '/404', hidden: true}
]

export default defaultRouter
